import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import { isActionRunSuccessfully } from "../../../Lib/Utils/validationUtil";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { getBookingDetailDataAction } from "../BookingDetail/GetBookingDetailDataAction";
import { passengerTypeAction } from "../Search/GetPassengerTypesAction";
import { getTicketOptionsAction } from "../Search/GetTicketOptionsAction";
import { getPassBookingObjectAction } from "./GetPassBookingObjectAction";

export class RedirectToPassBookingDetailPageAction extends BaseAction<void, { bookingId: string }> {
  public async run(): Promise<void> {
    const { bookingId } = this.params!;

    if (!bookingId) { return; }

    getPassBookingObjectAction.setParams({
      bookingId: bookingId,
    })
    await getPassBookingObjectAction.execute();

    if (isActionRunSuccessfully(getPassBookingObjectAction) && getPassBookingObjectAction.result) {
      const passBookingObject = getPassBookingObjectAction.result;

      updateRecoilState("selectedPassBookingAtom", passBookingObject);
      updateRecoilState("offersPageViewAtom", "bookedPassDetail");

      _eventBus.emit({
        eventName: "ROUTE_CHANGE",
        data: `/offers?paymentSuccess=true`,
      });

      setTimeout(async () => {
        await getTicketOptionsAction.execute()
        await passengerTypeAction.execute();
        updateRecoilState("passengerTypesStateAtom", passengerTypeAction.result);

        getBookingDetailDataAction.setParams({
          bookingId: passBookingObject.booking?.booking.id
        })
        await getBookingDetailDataAction.execute()
        // TODO: check this
        // prepareBookingSummaryAction.setParams(passBookingObject.booking?.booking || {});
        // await prepareBookingSummaryAction.execute();

        _eventBus.emit({
          eventName: evtTree.CMSOffers.BookedPass.Click,
          data: {
            passBooking: passBookingObject,
          }
        });
      }, 1500);

    } else {
      console.error("Failed to fetch pass booking object for bookingId:", bookingId);
    }
  }
}

export const redirectToPassBookingDetailPageAction = new RedirectToPassBookingDetailPageAction();
